<template>
  <div class="preview-lines" :class="`preview-lines--${side}`">
    <table v-if="columns.length">
      <thead>
        <tr>
          <th class="preview-lines__row-num" scope="col">#</th>
          <th v-for="col in columns" :key="col.field" scope="col">{{ col.label }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="row in rows"
          :key="row.index"
          :class="{ 'preview-lines__row--ghost': row.ghost }"
        >
          <td class="preview-lines__row-num">{{ row.index + 1 }}</td>
          <td
            v-for="cell in row.cells"
            :key="cell.field"
            :class="{ 'preview-lines__cell--changed': cell.was !== undefined }"
          >
            <template v-if="row.ghost">—</template>
            <template v-else>{{ cell.value }}</template>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else class="preview-lines__empty">No line items.</p>
  </div>
</template>

<script setup lang="ts">
import type { LineRow } from '../previewDiff';

defineProps<{
  columns: { field: string; label: string }[];
  rows: LineRow[];
  side: 'before' | 'after';
}>();
</script>

<style scoped lang="scss">
.preview-lines {
  overflow-x: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    font-variant-numeric: tabular-nums;
  }

  th,
  td {
    padding: 4px 8px;
    border-bottom: 1px solid #e5e7eb;
    text-align: left;
    white-space: nowrap;
    vertical-align: top;
  }

  th {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #6b7280;
    background: #f9fafb;
  }

  &__row-num {
    width: 1%;
    color: #9ca3af;
    font-variant-numeric: tabular-nums;
    text-align: right;
  }

  &__row--ghost td {
    color: #d1d5db;
    background: repeating-linear-gradient(
      45deg,
      transparent,
      transparent 6px,
      rgba(229, 231, 235, 0.6) 6px,
      rgba(229, 231, 235, 0.6) 12px
    );
  }

  &--after &__cell--changed {
    color: #065f46;
    font-weight: 600;
    background: rgba(187, 247, 208, 0.35);
  }

  &--before &__cell--changed {
    color: #b91c1c;
    text-decoration: line-through;
    text-decoration-color: rgba(185, 28, 28, 0.45);
    background: rgba(254, 202, 202, 0.3);
  }

  &__empty {
    margin: 0;
    padding: 6px 4px;
    font-size: 12px;
    color: #9ca3af;
    font-style: italic;
  }
}
</style>
